import { Tooltip, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import React from 'react';

import AlertInfo from '@/assets/icons/alert-info.svg?react';
import TrashCanIcon from '@/assets/icons/trash.svg?react';

interface Props {
  readonly error?: string | null;

  onDelete?(): void;
}

export const FileFormFieldError: React.FC<Props> = (props: Props): React.ReactElement => {
  const { error, onDelete } = props;
  const {
    palette: { error: color },
  } = useTheme();

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={error} placement="top">
        <Box display="flex" alignItems="center" justifyContent="center" width={40} height={40}>
          <AlertInfo fill={color.main} />
        </Box>
      </Tooltip>
      <IconButton onClick={onDelete}>
        <TrashCanIcon />
      </IconButton>
    </Box>
  );
};
